import React from 'react';

import BaseCard, { BaseCardType, BGDark } from 'components/molecules/base-card';
import Slider, { SliderType } from 'components/molecules/slider';
import { ButtonType } from 'components/atoms/button';

import { breakpoints, useScreenService } from 'hooks/use-screen-service';

import {
  StyledContent,
  StyledDots,
  StyledSubHeading,
  StyledTitle,
  StyledWrapper,
} from './industries-slider.styles';

export type IndustriesSliderType = {
  cards: BaseCardType[];
  linkButton: ButtonType;
  subHeading: string;
  heading: string;
  isWhite?: boolean;
  specialColorBg?: boolean;
  bgDark?: BGDark;
};

export type IsWhiteType = {
  isWhite?: boolean;
  specialColorBg?: boolean;
};
const IndustriesSlider = ({
  cards,
  linkButton,
  subHeading,
  heading,
  isWhite = false,
  specialColorBg = false,
  bgDark = false,
}: IndustriesSliderType) => {
  const { isXlUp } = useScreenService();
  const cardsSlides = cards.map((card) => (
    <BaseCard {...card} variant="industries" bgDark={bgDark} showDescription="desktop" />
  ));

  const cardSliderOptions: SliderType['options'] = {
    slidesPerView: 1.7,
    spaceBetween: 16,
    watchSlidesProgress: true,
    // scrollbar: true,
    scrollbar: { draggable: true },
    breakpoints: {
      [breakpoints.sm]: {
        slidesPerView: 3,
      },
      [breakpoints.md]: {
        slidesPerView: 4,
      },
    },
  };

  return (
    <StyledWrapper isWhite={isWhite} specialColorBg={specialColorBg}>
      {isXlUp ? <StyledDots isWhite={isWhite} width={2} height={13} color="whiteAlpha40" /> : null}
      <StyledContent isWhite={isWhite}>
        {isWhite ? (
          <StyledSubHeading variant="title6" color="gray40" component="h3">
            {subHeading}
          </StyledSubHeading>
        ) : (
          <StyledSubHeading variant="title6" color="whiteAlpha40" component="h3">
            {subHeading}
          </StyledSubHeading>
        )}
        {isWhite ? (
          <StyledTitle variant="title2" color="gray100" html={heading} />
        ) : (
          <StyledTitle variant="title2" color="white" html={heading} />
        )}
        <Slider
          {...{
            slides: cardsSlides,
            options: cardSliderOptions,
            variant: 'primary',
            linkButton,
          }}
        />
      </StyledContent>
    </StyledWrapper>
  );
};

export default IndustriesSlider;
